import { useLocation } from 'react-router-dom';
import { Title } from '../common/Title';
import { Link } from '../common/Link';
import { useSound } from '../../hooks/audio/useSound';
import { useAppStore } from '../../store/useAppStore';
import { SoundToggle } from '../ui/SoundToggle';

export const Header: React.FC = () => {
  const { pathname } = useLocation();
  const { playUI, updateWind } = useSound();
  const isFixed = pathname !== '/about';

  return (
    <header
      className={`flex justify-between p-8 z-20 ${isFixed ? 'fixed top-0 left-0 right-0' : 'relative'}`}
    >
      <Title />
      <nav
        className="flex items-center gap-2 opacity-0 animate-fade-in text-black"
        style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}
      >
        <SoundToggle compact />
        <Link 
          href={pathname === '/about' ? '/' : '/about'} 
          size="lg"
          onMouseDown={() => {
            if (pathname !== '/about') {
              useAppStore.getState().setHasVisitedAbout(true);
              useAppStore.getState().setVelocity(0);
              updateWind(0);
            }
          }}
          onMouseEnter={() => playUI('nav', 'enter')}
          onMouseLeave={() => playUI('nav', 'leave')}
        >
          {pathname === '/about' ? 'Work' : 'About'}
        </Link>
      </nav>
    </header>
  );
};
